import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import { keyframes } from "@mui/system";
import bee from "../../assets/bee.gif";
import bear from "../../assets/bear.gif";
import star from "../../assets/star.gif";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import campersMain from "../../assets/shop/campers/campersMain.jpg";
import campers01 from "../../assets/shop/campers/campers01.jpg";
import campers02 from "../../assets/shop/campers/campers02.jpg";
import thingstodo from "../../assets/shop/thingsToDo/thingsMain.JPG";
import things01 from "../../assets/shop/thingsToDo/things01.JPG";
import things02 from "../../assets/shop/thingsToDo/things02.JPG";
import badge from "../../assets/shop/nail/badge.jpg";
import badge02 from "../../assets/shop/nail/badge02.jpg";
import card from "../../assets/shop/nail/card.JPG";
import catTape01 from "../../assets/shop/nail/catTape01.jpg";
import catTape02 from "../../assets/shop/nail/catTape02.jpg";
import egyptTape01 from "../../assets/shop/nail/egyptTape01.jpg";
import egyptTape02 from "../../assets/shop/nail/egyptTape02.jpg";
import inthecafe01 from "../../assets/shop/nail/inthecafe01.jpg";
import inthecafe02 from "../../assets/shop/nail/inthecafe02.jpg";
import inthecafe03 from "../../assets/shop/nail/inthecafe03.jpg";
import monster01 from "../../assets/shop/nail/monster01.jpg";
import monster02 from "../../assets/shop/nail/monster02.jpg";

import animalTape01 from "../../assets/shop/nail/animalTape01.jpg";
import animalTape02 from "../../assets/shop/nail/animalTape02.jpg";
import animalTape03 from "../../assets/shop/nail/animalTape03.jpg";
import animalTape04 from "../../assets/shop/nail/animalTape04.jpg";
import animalTape05 from "../../assets/shop/nail/animalTape05.jpg";
import bagBiHungLu01 from "../../assets/shop/nail/bagBiHungLu01.jpg";
import bagBiHungLu02 from "../../assets/shop/nail/bagBiHungLu02.jpg";
import birthCard01 from "../../assets/shop/nail/birthCard01.jpg";
import birthCard02 from "../../assets/shop/nail/birthCard02.jpg";
import camperSticker01 from "../../assets/shop/nail/camperSticker01.jpg";
import camperSticker02 from "../../assets/shop/nail/camperSticker02.jpg";
import camperSticker03 from "../../assets/shop/nail/camperSticker03.jpg";
import camperSticker04 from "../../assets/shop/nail/camperSticker04.jpg";
import stamp1_01 from "../../assets/shop/nail/stamp1_01.jpg";
import stamp1_02 from "../../assets/shop/nail/stamp1_02.jpg";
import stamp1_03 from "../../assets/shop/nail/stamp1_03.jpg";
import stamp2_01 from "../../assets/shop/nail/stamp2_01.jpg";
import stamp2_02 from "../../assets/shop/nail/stamp2_02.jpg";
import stamp2_03 from "../../assets/shop/nail/stamp2_03.jpg";
import stamp3_01 from "../../assets/shop/nail/stamp3_01.jpg";
import stamp3_02 from "../../assets/shop/nail/stamp3_02.jpg";
import stamp3_03 from "../../assets/shop/nail/stamp3_03.jpg";
import thankCard01 from "../../assets/shop/nail/thankCard01.jpg";
import thankCard02 from "../../assets/shop/nail/thankCard02.jpg";



const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const products = [
    {
        id: 1,
        name: "明信片｜小怪獸",
        price: "$50",
        image: monster01,
        description: "孔版印刷｜148x105mm",
        gallery: [monster01, monster02] // Add all related images
    },
    // {
    //     id: 2,
    //     name: "待辦事項",
    //     price: "$?",
    //     image: thingstodo,
    //     description: "description02",
    //     gallery: [thingstodo, things01, things02]
    // },
    // {
    //     id: 3,
    //     name: "貓咪胸章",
    //     price: "$?",
    //     image: badge,
    //     description: "description03",
    //     gallery: [badge]
    // },
    {
        id: 4,
        name: "明信片｜生日卡5.0",
        price: "$50",
        image: card,
        description: "數位印刷｜145x95mm",
        gallery: [card]
    },
    // {
    //     id: 5,
    //     name: "貼紙｜campers",
    //     price: "$120",
    //     image: egyptTape01,
    //     description: "透明貼紙、白底貼紙各一｜商品尺寸85x180mm",
    //     gallery: [egyptTape01, egyptTape02]
    // },
    // {
    //     id: 6,
    //     name: "貼紙｜花園轉印貼",
    //     price: "$90",
    //     image: catTape01,
    //     description: "一份兩張｜100x150mm",
    //     gallery: [catTape01, catTape02]
    // },
    {
        id: 7,
        name: "紙膠帶｜埃及貓貓",
        price: "$180",
        image: egyptTape01,
        description: "日本和紙｜寬2.5cm、總長10m",
        gallery: [egyptTape01, egyptTape02]
    },
    {
        id: 8,
        name: "紙膠帶｜咪咪貓貓",
        price: "$180",
        image: catTape01,
        description: "日本和紙｜寬2.5cm、總長10m",
        gallery: [catTape01, catTape02]
    },
    // {
    //     id: 9,
    //     name: "紙膠帶｜animal love",
    //     price: "$180",
    //     image: catTape01,
    //     description: "日本和紙｜寬2.5cm、總長10m",
    //     gallery: [catTape01, catTape02]
    // },
    {
        id: 10,
        name: "便條紙｜ThiNgs to do 褐",
        price: "$80",
        image: thingstodo,
        description: "45 sheets｜150x58mm",
        gallery: [thingstodo, things01, things02]
    },
    // {
    //     id: 11,
    //     name: "便條紙｜ThiNgs to do 藍",
    //     price: "$80",
    //     image: thingstodo,
    //     description: "45 sheets｜150x58mm",
    //     gallery: [thingstodo, things01, things02]
    // },
    {
        id: 12,
        name: "金屬徽章｜喵姆貓貓",
        price: "$120",
        image: badge02,
        description: "",
        gallery: [badge02, badge]
    },
    {
        id: 13,
        name: "小海報｜喫茶店",
        price: "$100",
        image: inthecafe01,
        description: "孔版印刷｜300x150mm",
        gallery: [inthecafe01, inthecafe02, inthecafe03]
    },
    {
        id: 14,
        name: "餐具｜campers 露營摺疊杯",
        price: "",
        image: campers02,
        description: "",
        gallery: [campers02]
    },
    {
        id: 15,
        name: "餐具｜campers 露營餐具組",
        price: "",
        image: campers01,
        description: "",
        gallery: [campers01]
    },
    {
        id: 16,
        name: "餐具｜campers 露營摺疊碗",
        price: "",
        image: campersMain,
        description: "",
        gallery: [campersMain]
    },
    {
        id: 17,
        name: "紙膠帶｜animal love",
        price: "$180",
        image: animalTape01,
        description: "日本和紙｜寬2.5cm、總長10m",
        gallery: [animalTape01, animalTape02, animalTape03, animalTape04, animalTape05]
    },
    {
        id: 18,
        name: "",
        price: "",
        image: bagBiHungLu01,
        description: "",
        gallery: [bagBiHungLu01, bagBiHungLu02]
    },
    {
        id: 19,
        name: "明信片｜生日卡6.0",
        price: "$50",
        image: birthCard01,
        description: "數位印刷｜145x95mm",
        gallery: [birthCard01, birthCard02]
    },
    {
        id: 20,
        name: "貼紙｜campers",
        price: "$120",
        image: camperSticker01,
        description: "透明貼紙、白底貼紙各一｜商品尺寸85x180mm",
        gallery: [camperSticker01, camperSticker02, camperSticker03, camperSticker04]
    },
    {
        id: 21,
        name: "",
        price: "",
        image: stamp1_01,
        description: "",
        gallery: [stamp1_01, stamp1_02, stamp1_03]
    },
    {
        id: 22,
        name: "",
        price: "",
        image: stamp2_01,
        description: "",
        gallery: [stamp2_01, stamp2_02, stamp2_03]
    },
    {
        id: 23,
        name: "",
        price: "",
        image: stamp3_01,
        description: "",
        gallery: [stamp3_01, stamp3_02, stamp3_03]
    },
    {
        id: 24,
        name: "明信片｜謝謝尼",
        price: "$40",
        image: thankCard01,
        description: "孔版印刷｜105x105mm",
        gallery: [thankCard01, thankCard02]
    },
];

const ShopDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const product = products.find((p) => p.id === parseInt(id));

    const [mainImage, setMainImage] = useState(product?.image || bee);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        setFade(true);
    }, []);

    if (!product) {
        return <Typography variant="h5" sx={{ textAlign: "center", mt: 5 }}>Product Not Found</Typography>;
    }

    return (
        <Box
            sx={{
                marginTop: "20px",
                padding: "100px",
                animation: `${fadeIn} 0.5s ease-in`,
                opacity: fade ? 1 : 0,
            }}
        >
            {/* Image Layout Section */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "800px",
                    margin: "0 auto",
                    marginBottom: "80px",
                }}
            >
                {/* Main Image */}
                <Box
                    sx={{
                        width: "min(500px, 100%)",
                        aspectRatio: "1 / 1",
                        overflow: "hidden",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                    }}
                >
                    <img
                        src={mainImage}
                        alt={product.name}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            display: "block",
                        }}
                    />
                </Box>

                {/* Square Thumbnails */}
                <Box
                    sx={{
                        display: "flex",
                        gap: "12px",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "16px",
                        flexWrap: "wrap",
                    }}
                >
                    {product.gallery.map((image, index) => (
                        <Box
                            key={index}
                            onClick={() => setMainImage(image)}
                            sx={{
                                width: "70px",
                                height: "70px",
                                flexShrink: 0,
                                borderRadius: "4px",
                                overflow: "hidden",
                                cursor: "pointer",
                                border:
                                    mainImage === image
                                        ? "2px solid #000"
                                        : "1px solid #ddd",
                                transition: "all 0.2s ease",
                                opacity: mainImage === image ? 1 : 0.7,

                                "&:hover": {
                                    opacity: 1,
                                    transform: "scale(1.05)",
                                },
                            }}
                        >
                            <Box
                                component="img"
                                src={image}
                                alt={`Thumbnail ${index + 1}`}
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* Product Info */}
            <Box
                sx={{
                    width: "min(500px, 100%)",
                    margin: "0 auto",
                    textAlign: "left",
                }}
            >
                <Box
                    sx={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        color: "#333",
                        marginTop: "20px",
                    }}
                >
                    {product.name}
                </Box>

                <Box
                    sx={{
                        fontSize: "1rem",
                        color: "#888",
                        marginTop: "5px",
                    }}
                >
                    {product.price}
                </Box>

                <Box
                    sx={{
                        fontSize: "0.8rem",
                        color: "#666",
                        lineHeight: 1.6,
                    }}
                >
                    {product.description}
                </Box>
            </Box>

            {/* Navigation Footer Row */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    borderTop: "1px solid #ddd",
                    marginTop: 8,
                    paddingTop: 4,
                    paddingBottom: 4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "1rem",
                    fontWeight: 500,
                    color: "#444",
                }}
            >
                <Link to="/shop" style={{ textDecoration: "none", color: "#444" }}>
                    Back to Shop
                </Link>
            </Box>
        </Box>
    );
};

export default ShopDetail;
